import { ArrowRight, MapPin } from "lucide-react";
import { CanonicalLink as Link } from "@/components/CanonicalLink";

const zones = [
  { ville: "Vieux-Longueuil", href: "/plombier-vieux-longueuil/", description: "Urgences et réparations de plomberie au quotidien." },
  { ville: "Saint-Hubert", href: "/plombier-saint-hubert/", description: "Fuites, robinetterie et nouveaux raccordements." },
  { ville: "Greenfield Park", href: "/plombier-greenfield-park/", description: "Entretien et remplacement de vos installations." },
  { ville: "Saint-Lambert", href: "/plombier-saint-lambert/", description: "Plomberie pour vos projets de cuisine et de salle de bain." },
];

export function ServiceAreas() {
  return (
    <section id="zones-desservies" aria-labelledby="coverage-heading" data-testid="service-areas" className="scroll-mt-24 bg-slate-50 py-14 md:py-20">
      <div className="mx-auto max-w-5xl px-4 text-center md:px-6">
        <div className="mx-auto mb-5 h-0.5 w-10 bg-accent" aria-hidden="true" />
        <h2 id="coverage-heading" className="text-3xl font-bold leading-tight tracking-tight text-primary md:text-4xl">
          Nous intervenons sur la Rive-Sud
        </h2>
        <p className="mx-auto mt-4 max-w-xl leading-relaxed text-muted-foreground">
          Nos{" "}
          <Link href="/plombier-rive-sud/" className="underline decoration-slate-300 underline-offset-4 transition-colors hover:text-primary focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary">
            plombiers de proximité
          </Link>{" "}
          interviennent pour vos urgences et vos travaux.
        </p>
        <ul className="my-8 grid grid-cols-1 gap-4 min-[360px]:grid-cols-2 md:my-9 md:grid-cols-4" aria-label="Quelques secteurs desservis">
          {zones.map((zone) => (
            <li key={zone.href}>
              <Link href={zone.href} className="group block h-full rounded-lg border border-slate-200 bg-white px-4 py-6 transition-[border-color,box-shadow] hover:border-primary/30 hover:shadow-sm focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary md:px-5">
                <span className="mx-auto mb-4 flex h-10 w-10 items-center justify-center rounded-full bg-accent/10 text-accent transition-colors group-hover:bg-accent/15" aria-hidden="true">
                  <MapPin className="h-5 w-5" strokeWidth={1.75} />
                </span>
                <h3 className="text-base font-semibold text-primary transition-colors group-hover:text-accent md:text-lg">{zone.ville}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{zone.description}</p>
              </Link>
            </li>
          ))}
        </ul>
        <Link href="/zones/" className="inline-flex min-h-11 items-center justify-center gap-2 text-sm font-semibold text-accent underline decoration-accent/40 underline-offset-4 transition-colors hover:text-primary focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary">
          Voir toutes les zones desservies
          <ArrowRight className="h-4 w-4" aria-hidden="true" />
        </Link>
      </div>
    </section>
  );
}